import { Base } from '@studiometa/js-toolkit';

/**
 * @typedef {{}} FormProps
 */

/**
 * Form Form.
 * @augments {Base<FormProps>}
 */
export default class Form extends Base {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Form',
  };

  /**
   *
   */
  mounted() {
    const inputFields = document.querySelectorAll(
      '.ginput_container input, .ginput_container textarea',
    );

    inputFields.forEach((inputField) => {
      const fieldWrapper = inputField.closest('.gfield');
      const label = fieldWrapper.querySelector('.gfield_label');

      if (fieldWrapper && label) {
        inputField.addEventListener('focus', function () {
          fieldWrapper.classList.add('active');
          label.classList.add('active');
        });

        inputField.addEventListener('blur', function () {
          fieldWrapper.classList.remove('active');
          label.classList.remove('active');

          if (inputField.value.trim() !== '') {
            fieldWrapper.classList.add('filled');
            label.classList.add('filled');
          } else {
            fieldWrapper.classList.remove('filled');
            label.classList.remove('filled');
          }
        });

        if (inputField.value.trim() !== '') {
          fieldWrapper.classList.add('filled');
          label.classList.add('filled');
        }
      }
    });
  }
}
